<template>
  <div class="windows__table5B-wrap">
    <table class="windows__table5B" v-for="(windowObj, m) in step5B.thermal_trans_windows" :key="windowObj.window">
      <thead>
        <tr>
          <td colspan="3" style="background-color:#c8f0e0">{{ windowObj.window }}</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="background-color:#dedede">Layers</td>
          <td style="background-color:#dedede">Opaque construction {{ windowObj.window }}</td>
          <td style="background-color:#dedede">Thermal Resistance</td>
        </tr>
        <!-- <tr>
          <td style="background-color:#FCDEC0">Fixed - ECBC-R</td>
          <td style="background-color:#FCDEC0">Interior surface film thermal resistance</td>
          <td style="background-color:#FCDEC0">0.13</td>
        </tr>
        <tr>
          <td style="background-color:#FCDEC0">Fixed - ECBC-R</td>
          <td style="background-color:#FCDEC0">Exterior surface film thermal resistance</td>
          <td style="background-color:#FCDEC0">0.04</td>
        </tr> -->
        <tr v-for="(layerObj, j) in step5B.thermal_trans_windows[m].layer_arr_obj">
          <td style="background-color: #c4def5">{{ layerObj.layer }}</td>
          <td style="background-color: #c4def5">{{ step5B.thermal_trans_windows[m].layer_arr_obj[j].material_n_resistance.material || `-----` }}</td>
          <td style="background-color: #c4def5">{{ step5B.thermal_trans_windows[m].layer_arr_obj[j].material_n_resistance.thermal_resistance || 0 }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  computed: {
    step5B: {
      get: function() {
        // console.log('Wall Index', this.wallIndex);
        return this.$store.state.schema.inputs.step5B;
      },
      set: function(step5B) {
        this.$store.dispatch('setStep5B', step5B);
      },
    },
  },
};
</script>

<style lang="scss">
.windows__table5B-wrap {
  display: flex;
}
.windows__table5B {
  padding: 12px;
  width: 100%;
  // border: 1px solid #a4abb3;
  border-spacing: 0px;
  .table-heading-wall5B {
    background-color: #c4def5;
    padding: 4px;
    font-size: 20px;
    background-color: #c8f0e0;
    color: #2cb17c;
  }
  td {
    border: 1px solid #a4abb3;
    border-spacing: 0px;
    padding: 2px;
    text-align: center;
    font-size: 11px;
  }
}
</style>
